import styled from 'styled-components';

import { ScreenSize } from 'shared';

export const StyledContainer = styled.div<{ size: ScreenSize }>`
  max-width: ${props => props.theme.breakpoints[props.size]}px;
  padding: 1rem;
  margin: 0 auto;
`;
